module.exports = __webpack_public_path__ + "3eae09df9261783d44e2416c39bc7eb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/P28 - TempleApproach - Drop Pod Assault 02.jpg
// module id = 152
// module chunks = 0